import { render } from "./SendMailModal.vue?vue&type=template&id=71338da3&scoped=true&ts=true"
import script from "./SendMailModal.vue?vue&type=script&lang=ts"
export * from "./SendMailModal.vue?vue&type=script&lang=ts"

import "./SendMailModal.vue?vue&type=style&index=0&id=71338da3&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71338da3"]])

export default __exports__